import { createFeatureRoleMappingAPI, creteFeatureAPI, deleteFeatureAPI, deleteFeatureRoleMappingAPI, featureAccessByFeatureIdAPI, featureGetByIdAPI, featureNotInRolesAPI, featurePagingAPI, featureRolesMappingAPI, updateFeatureAPI } from "../../../api/url"
import { formatTreeViewData } from "../../../common/commonFunctions"
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, setReducerState, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from "../../../store/store"
import { getLocalStorageItem } from "../../../utils/storageHelper"
import { APICallFunction } from "../role/apiCall"
import { FeaturesKeys } from "./entity"
const { dispatch } = store

export const getFeaturesPaging = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: FeaturesKeys.paging,
        url: featurePagingAPI,
        request: { ..._request, ['ApplicationId']: getLocalStorageItem('ApplicationId') },
    }))
}

export const deleteFeature = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: FeaturesKeys.delete,
        url: deleteFeatureAPI,
        request: { FeatureId: _request },
    }))
}

export const getFeatureRoleMapping = async (  dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: FeaturesKeys.getRole,
        url: featureRolesMappingAPI, 
        request: { ..._request },
    }))
}


export const deleteFeatureRoleMapping = async (  dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: FeaturesKeys.deleteRole,
        url: deleteFeatureRoleMappingAPI, // change api
        request: [_request] ,
    }))
}

export const featuresFeatureAccessMapping = async (  dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: FeaturesKeys.getFeatureAccess,
        url: featureAccessByFeatureIdAPI,
        request: { ..._request },
    }))
}

export const DeleteFeatureAccess = async (  dispatch: AppDispatch, _request: Object) => {
    // await dispatch(getByBodyAPI({
    //     key: FeaturesKeys.deleteFeatureAccess,
    //  //   url: , 
    //     request: { ..._request },
    // }))
}

export const getFeaturebyId: APICallFunction = async (params) => {
    const { key = FeaturesKeys.get, request = {}, url = featureGetByIdAPI(request?.id) } = params;
    const res = await dispatch(getByIdAPI({ key: key, url: url }));
    return res?.payload?.value;
}

export const createFeature: APICallFunction = async (params) => {
    const { key = FeaturesKeys.create, request = {}, url = creteFeatureAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateFeature: APICallFunction = async (params) => {
    const { key = FeaturesKeys.update, request = {}, url = updateFeatureAPI(request.id) } = params;
    const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getFeatureNotInRoles: APICallFunction = async (params) => {
    const { key = FeaturesKeys.notInRole, request = {}, url = featureNotInRolesAPI } = params;
    const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const addFeatureRoleMapping: APICallFunction = async (params) => {
    const { key = FeaturesKeys.addRole, request = {}, url = createFeatureRoleMappingAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getFeaturesTree: APICallFunction = async (params) => {
    const { key = FeaturesKeys.tree, request = {}, url = featureAccessByFeatureIdAPI } = params;
    request.FeatureId = request.id
    let res = await dispatch(getByBodyAPI({ key: '', url: url, request: request }));
    res = { data: formatTreeViewData(res?.payload?.data, 'ChildName', 'DisplayName') };

    dispatch(setReducerState({ key: key, value: res }));
    return res;
}